import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";
import moment from "moment";

export const getChartOfAccountsPaginated = ({
  churchId,
  page,
  pageSize,
  startDate = moment().startOf("month").format("YYYY-MM-DD"),
  endDate = moment().endOf("month").format("YYYY-MM-DD")
}) => {
  const params = new URLSearchParams({
    page,
    per_page: pageSize
  });

  if (startDate) {
    params.append("start_date", startDate);
  }

  if (endDate) {
    params.append("end_date", endDate);
  }

  return axios.get(
    `/churches/${churchId}/chart-of-accounts-paginated?${params.toString()}`
  );
};

export const useChartOfAccountsPaginated = ({
  churchId,
  config,
  page,
  pageSize,
  startDate = moment().startOf("month").format("YYYY-MM-DD"),
  endDate = moment().endOf("month").format("YYYY-MM-DD")
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "chart-accounts-paginated",
      churchId,
      page,
      pageSize,
      startDate,
      endDate
    ],
    queryFn: () =>
      getChartOfAccountsPaginated({
        churchId,
        page,
        pageSize,
        startDate,
        endDate
      })
  });
};
